// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root___aqYY","error":"Textarea_error__3DNDs","readonly":"Textarea_readonly__1gmpK","disabled":"Textarea_disabled__22DCZ"};